import { createSlice } from '@reduxjs/toolkit';

import { getSupplyOrders } from '../../apis';
import { receiveOrder } from './api';

export const MaterialUnitSlice = createSlice({
    name: 'materialUnit',
    initialState: {
        isLoading: false,
        data : [],
        error: '',
        receiveSuccess: false,
    },

    reducers: {
        // updateShipmentStyleRowData: (state, action) => {
        //     return {
        //         ...state,
        //         data: {
        //             ...state.data,
        //             current_shipment: [...(state.data.current_shipment.filter(item => item.style_id !== action.payload.style_id)), action.payload]
        //         }
        //     }
        // },
        resetReceiveSuccess: (state, action) => {
          return {
            ...state,
            receiveSuccess: action.payload
          }
        },
        clearErrorState: (state, action) => {
          return {
            ...state,
            error: action.payload
          }
        }
    },

    extraReducers: (builder) => {
        builder.addCase(getSupplyOrders.pending, (state, action) => {
            state.isLoading = true;
        })
        builder.addCase(getSupplyOrders.fulfilled, (state, action) => {
            state.isLoading = true;
            state.error = '';
            state.data = action.payload.data
        })
        builder.addCase(getSupplyOrders.rejected, (state, action) => {
            state.error = action.payload.message
            state.isLoading = false;
        })
        builder.addCase(receiveOrder.pending, (state, action) => {
            state.isLoading = true;
        })
        builder.addCase(receiveOrder.fulfilled, (state, action) => {
            state.isLoading = false;
            state.error = '';
            state.receiveSuccess = true
        })
        builder.addCase(receiveOrder.rejected, (state, action) => {
            state.error = action.payload.message
            state.isLoading = false;
        })
    }
})

export const { resetReceiveSuccess, clearErrorState } = MaterialUnitSlice.actions


export default MaterialUnitSlice.reducer